import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/footer/Footer.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/blog/BlogArticleCard.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/(frontend)/blog/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/accordionSection/accordionSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/cardSection/CardSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/gallerySection/GallerySection.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/sections/textSection/TextSection.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/sections/workSection/WorkSection.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SeoLinksSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/tag/tag.module.css");
